export default __webpack_public_path__ + "static/media/finance-data.d1e2f8b0.svg";